import { useEffect, useState } from "react";
import setThemeColor from "../../utils/setThemeColor/setThemeColor";
import styles from "./InfoPage.module.css";
import { NavMenu } from "../../components/feature/NavMenu/NavMenu";
import { RootState } from "../../redux/store";
import { IOptions } from "../../components/feature/NavMenu/elements/AdditionalOptionsMenu/AdditionalOptionsMenu";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import setWebPageTitle from "../../utils/setWebPageTitle/setWebPageTitle";
import setWebPagePreviewImage from "../../utils/setWebPagePreviewImage/setWebPagePreviewImage";

const MorePage: React.FC = () => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector((state: RootState) => state.client.isLoggedIn);
  const [options, setOptions] = useState<IOptions[]>([]);
  const isMobile: boolean = useSelector((state: RootState) => state.client.isMobile);

  useEffect(() => {
    setThemeColor("#ffffff");
    setWebPageTitle("Info");
    setWebPagePreviewImage();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      setOptions([
        {
          link: "/",
          name: t("containers.myRecipesPage.title"),
          icon: <i className="bi bi-collection"></i>,
        },
        {
          link: "/explore",
          name: t("containers.explorePage.title"),
          icon: <i className="bi bi-globe-americas"></i>,
        },
        {
          link: "/add",
          name: t("containers.addRecipePage.title"),
          icon: <i className="bi bi-plus-circle"></i>,
        },
        {
          link: "/settings",
          name: t("containers.settingsPage.title"),
          icon: <i className="bi bi-gear"></i>,
        },
      ]);
    } else {
      setOptions([
        {
          link: "/explore",
          name: t("containers.explorePage.title"),
          icon: <i className="bi bi-globe-americas"></i>,
        },
        {
          link: "/settings",
          name: t("containers.settingsPage.title"),
          icon: <i className="bi bi-gear"></i>,
        },
      ]);
    }
  }, [isLoggedIn]);

  return (
    <div>
      <NavMenu
        title={
          <span>
            <i className="bi bi-info-circle"></i> {t("containers.infoPage.title")}
          </span>
        }
        options={options}
      />
      {isMobile && (
        <p className={styles.title}>
          <i className="bi bi-info-circle"></i> {t("containers.infoPage.title")}
        </p>
      )}
      <div
        className={
          useSelector((state: RootState) => state.client.isMobile) ? styles.containerMobile : styles.containerDesktop
        }
      >
        <h5 className="my-3">{t("containers.infoPage.legal")}</h5>
        <p>Copyright © 2025 WILCZ PARTNERS S.R.L. All Rights Reserved.</p>
        <h5 className="my-3">{t("containers.infoPage.contact")}</h5>
        <p>contact@wilcz.com</p>
        <h5 className="my-3">Company Identity Data</h5>
        <div className={styles.companyInfo}>
          <div>WILCZ PARTNERS S.R.L.</div>
          <div>Str. Tudor Arghezi Nr. 8-10, Fl. 3, Office DSK3_01</div>
          <div>Sector 2, Bucharest, Romania, EU</div>
          <div>postal code: 020945</div>
          <div>Company Registration Number: J2025045753007</div>
          <div>European Unique Identifier (EUID): ROONRC.J2025045753007</div>
          <div>CUI: 52037274</div>
          <div>Share Capital: 200 RON</div>
          <div>
            Email:{" "}
            <a href="mailto:contact@wilcz.com" style={{ color: "inherit", textDecoration: "none" }}>
              contact@wilcz.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MorePage;
